var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMove(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.333 1.99984H6.99967L6.05967 1.05984C5.80634 0.806504 5.46634 0.666504 5.11301 0.666504H1.66634C0.933008 0.666504 0.333008 1.2665 0.333008 1.99984V9.99984C0.333008 10.7332 0.933008 11.3332 1.66634 11.3332H12.333C13.0663 11.3332 13.6663 10.7332 13.6663 9.99984V3.33317C13.6663 2.59984 13.0663 1.99984 12.333 1.99984ZM6.99967 8.5265V7.33317H4.99967C4.63301 7.33317 4.33301 7.03317 4.33301 6.6665C4.33301 6.29984 4.63301 5.99984 4.99967 5.99984H6.99967V4.8065C6.99967 4.5065 7.35967 4.35984 7.56634 4.57317L9.42634 6.43317C9.55968 6.5665 9.55968 6.77317 9.42634 6.9065L7.56634 8.7665C7.35967 8.97317 6.99967 8.8265 6.99967 8.5265Z",
    fill: "#8C8C8C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMove);
export default __webpack_public_path__ + "static/media/Move.03fb6bc421a9fe368605930032d86f50.svg";
export { ForwardRef as ReactComponent };